/** Indian Rupee symbol for labels and compact displays. */
export const INR_SYMBOL = "₹";

export type FormatInrOptions = {
  maximumFractionDigits?: number;
};

/** Formats a number as Indian Rupees (e.g. ₹1,23,456). */
export function formatInr(value: number, options?: FormatInrOptions): string {
  const n = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: options?.maximumFractionDigits ?? 0,
  }).format(n);
}

/** Compact rupee display for charts (e.g. ₹12.5L). */
export function formatInrCompact(value: number): string {
  if (!Number.isFinite(value)) return `${INR_SYMBOL}0`;
  const compact = new Intl.NumberFormat("en-IN", { notation: "compact", maximumFractionDigits: 1 });
  return `${INR_SYMBOL}${compact.format(value)}`;
}
